import { defineMessages } from 'react-intl'

export default defineMessages({
  trackYourHabitsTitle: {
    id: 'Home.trackYourHabits.title',
    defaultMessage: 'Track your habits',
  },
  trackYourHabitsBody: {
    id: 'Home.trackYourHabits.body',
    defaultMessage:
      'Log your meals and workouts to track your progress. We’ve made things fast and easy with shortcuts to your favorite meals and a huge library of foods. Hey, we even have 3D Touch, if your phone can handle it.',
  },
  feedbackAndSupportTitle: {
    id: 'Home.feedbackAndSupport.title',
    defaultMessage: 'Get the feedback and support you need',
  },
  feedbackAndSupportBody: {
    id: 'Home.feedbackAndSupport.body',
    defaultMessage:
      'We’ll keep you on track and in the right mindset with daily feedback, suggestions and the occasional motivational cheer.',
  },
  feedbackAndSupportMoreFeatures: {
    id: 'Home.feedbackAndSupport.moreFeatures',
    defaultMessage: 'More Features',
  },
  appStoreReviewsTitle: {
    id: 'Home.appStoreReviews.title',
    defaultMessage: 'App Store reviews',
  },
  appStoreReviewsText1: {
    id: 'Home.appStoreReviews.text1',
    defaultMessage:
      '5/5 loveee this app, helps me stay on track and it’s easy to use! Best fitness app to keep track!',
  },
  appStoreReviewsText2: {
    id: 'Home.appStoreReviews.text2',
    defaultMessage:
      'Seriously, I’ve tried it all. Get this! It’s super easy, and if you want personalized help it’s CHEAP and WORTH EVERY PENNY. I’m a happier, healthier gal.',
  },
  appStoreReviewsText3: {
    id: 'Home.appStoreReviews.text7',
    defaultMessage:
      'I love this app! It has so many features and great advice. With the different meal plans and exact calorie counts, this app was perfect for me.',
  },
  homepage_reasons_for_premium: {
    id: 'homepage_reasons_for_premium',
    defaultMessage:
      'You’re 4x more likely to reach your goal with the tools, tips and tastes of Premium.',
  },
  homepage_motivate_to_sign_up: {
    id: 'homepage_motivate_to_sign_up',
    defaultMessage:
      'The first step to a <b>healthier you</b> takes less than a minute.',
  },
  what_is_lifesum: {
    id: 'what_is_lifesum',
    defaultMessage: 'What is Lifesum?',
  },
  'CTA.diet_test_header_button': {
    id: 'CTA.diet_test_header_button',
    defaultMessage: 'Take the quiz',
  },
  diet_quiz_heading: {
    id: 'diet_quiz_heading',
    defaultMessage: 'What’s the right Meal Plan or Diet for you?',
  },
})
